import React from "react";
import "./footer.css";
import Footerlogo1 from "./footerlogo1.svg";
import Footerlogo2 from "./footerlogo2.svg";
import Footerlogo3 from "./footerlogo3.svg";
import Footerlogo4 from "./footerlogo4.svg";
import Footerlogo5 from "../navbar/logo2.png";
import Logo from "./Logo.png";
import Logo1 from "./FacebookLogo.png";
import Logo2 from "./YoutubeLogo.png";
import Logo3 from "./InstagramLogo.png";
const Footer = () => {
  const handleClick = (event) => {
    const href = event.target.getAttribute("href"); // Get the href attribute
    if (href && href.startsWith("#")) {
      event.preventDefault(); // Prevent default behavior (navigating to URL)

      const targetId = href.substring(1); // Get the id from the href attribute
      const targetElement = document.getElementById(targetId); // Get the target element

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" }); // Smooth scroll to the target element
      }
    }
  };
  return (
    <>
      <div className="footerbody">
        <div className="footerleft">
          <div className="footerleftflex">
            <a href="/">
              <img className="footerleftlogo1" src={Logo} alt="Logo" />
            </a>
          </div>
          <div className="footerSociallogo">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/share/XG5ZM5uXHykee2LC/?mibextid=JRoKGi"
            >
              <img className="footerleftlogodown" src={Logo1} alt="Logo1" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/@EcavoAgro"
            >
              <img className="footerleftlogodown" src={Logo2} alt="Logo2" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/nandi.foods"
            >
              <img className="footerleftlogodown" src={Logo3} alt="Logo3" />
            </a>
          </div>
        </div>

        <div className="footerright">
          <div className="footerrightitems">
            <div className="footerrightitemstop">Information</div>
            <ul>
              <li>
                <a className="footerrightitem" href="/aboutus">
                  About Us
                </a>
              </li>
              <li>
                <a className="footerrightitem" href="/support">
                  Support
                </a>
              </li>
              <li>
                <a className="footerrightitem" href="/trainee">
                  Trainee
                </a>
              </li>
              <li>
                <a className="footerrightitem" href="/privacy">
                  Privacy
                </a>
              </li>
              <li>
                <a className="footerrightitem" href="/disclaimer">
                  Disclaimer
                </a>
              </li>
            </ul>
          </div>
          <div className="footerrightitems">
            <div className="footerrightitemstop">Products</div>
            <ul>
              <div className="footerrightitemstopflex">
                <div>
                  <li>
                    <a className="footerrightitem" href="/aata">
                      Aata
                    </a>
                  </li>
                  <li>
                    <a className="footerrightitem" href="/sooji">
                      Sooji
                    </a>
                  </li>
                  <li>
                    <a className="footerrightitem" href="/salt">
                      Salt
                    </a>
                  </li>
                  <li>
                    <a className="footerrightitem" href="/pickles">
                      Pickles
                    </a>
                  </li>
                  <li>
                    <a className="footerrightitem" href="/maida">
                      Maida
                    </a>
                  </li>
                </div>
                <div>
                  <li>
                    <a className="footerrightitem" href="/dalia">
                      Dalia
                    </a>
                  </li>
                  <li>
                    <a className="footerrightitem" href="/besan">
                      Besan
                    </a>
                  </li>
                  <li>
                    <a className="footerrightitem" href="/spices">
                      Masala
                    </a>
                  </li>
                </div>
                <div>
                  <li>
                    <a
                      className="footerrightitem"
                      href="/spices#NANDI_Coriander_Powder"
                    >
                      Coriander Powder
                    </a>
                  </li>
                  <li>
                    <a
                      className="footerrightitem"
                      href="/spices#NANDI_Red_Chilli_Powder"
                      onClick={handleClick}
                    >
                      Red Chilli Powder
                    </a>
                  </li>
                  <li>
                    <a
                      className="footerrightitem"
                      href="/spices#NANDI_Turmeric_Powder"
                    >
                      Turmeric Powder
                    </a>
                  </li>
                  <li>
                    <a
                      className="footerrightitem"
                      href="/spices#NANDI_Sabji_Masala"
                    >
                      Sabji Masala
                    </a>
                  </li>
                  <li>
                    <a
                      className="footerrightitem"
                      href="/spices#NANDI_Meat_Masala"
                    >
                      Meat Masala
                    </a>
                  </li>
                </div>
              </div>
            </ul>
          </div>
          <div className="footerrightitems">
            <div className="footerrightitemstop">Contact Us</div>
            <ul>
              <li>
                <a className="footerrightitem" href="/contactus">
                  Head Office
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
          "background-color": "#F29B1A",
          padding: "1rem 0rem",
        }}
      >
        2024 Nandi Agro all rights Reserved. Designed and Developed by
      </div>
    </>
  );
};

export default Footer;
